/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostSsoResolveRequest
 */
export interface PostSsoResolveRequest {
    /**
     * 
     * @type {string}
     * @memberof PostSsoResolveRequest
     */
    challenge_id: string;
    /**
     * 
     * @type {string}
     * @memberof PostSsoResolveRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PostSsoResolveRequest
     */
    pkce_code_verifier: string;
}

/**
 * Check if a given object implements the PostSsoResolveRequest interface.
 */
export function instanceOfPostSsoResolveRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "pkce_code_verifier" in value;

    return isInstance;
}

export function PostSsoResolveRequestFromJSON(json: any): PostSsoResolveRequest {
    return PostSsoResolveRequestFromJSONTyped(json, false);
}

export function PostSsoResolveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSsoResolveRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'code': json['code'],
        'pkce_code_verifier': json['pkce_code_verifier'],
    };
}

export function PostSsoResolveRequestToJSON(value?: PostSsoResolveRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'code': value.code,
        'pkce_code_verifier': value.pkce_code_verifier,
    };
}

